/******************************************************
 *                  Timetables Ctrl
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("ExploitTimetablesEditCtrl", [
		"$scope", "$controller", "timetable", "Utils", "$uibModal", "ExploitTimetablesService", "toastr", "$location",
		function ($scope, $controller, timetable, Utils, $uibModal, ExploitTimetablesService, toastr, $location) {

		$controller("ExploitTimetablesEditOrNewParentCtrl", {$scope: $scope});

		var deleteModal;

		$scope.data.editedTimetable = timetable.data;

		$scope.data.mode = "edit";

		$scope.data.dayTypes = {};

		// MAJ des cases à cocher.
		for (var i = 0; i < timetable.data.dayTypes.length; i++) {
			var dayName = timetable.data.dayTypes[i];
			$scope.data.dayTypes[dayName] = true;
		}


		/**
         * Ouvrir la modal de suppression d'un calendrier.
         */
		$scope.openDeleteModal = function (timetable) {
			$scope.data.timetableToDelete = timetable;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope, "sm");
		};

		/**
         * Supprimer un calendrier, notifications, et fermer la modale en cas de succès.
         * @param timetable le calendrier à supprimer
         */
		$scope.deleteTimetable = function (timetable) {
			ExploitTimetablesService.deleteTimetable(timetable).then(() => {
				deleteModal.close();
				toastr.success("Le calendrier " + timetable.version + " a bien été supprimé.", "Calendrier supprimé");
				$location.path("/e-iti/timetables");
			}).catch((error) => {
				const data = error.data;
				let errorMessage = "Problème lors de la suppression du calendrier. ";
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};



	}]);
